var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _path5, _rect48, _path6, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _path7, _path8, _rect75, _rect76;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmoke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 125,
    viewBox: "0 0 73 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4668 7.00049C15.4668 5.89592 16.3622 5.00049 17.4668 5.00049H24.1335C25.238 5.00049 26.1335 5.89592 26.1335 7.00049V20.6449H15.4668V7.00049Z",
    fill: "#EB996E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.9668,
    y: 21.145,
    width: 9.66667,
    height: 14.6444,
    fill: "#F4DFD4",
    stroke: "#F4AB85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1338 4.00049C26.1338 2.89592 27.0292 2.00049 28.1338 2.00049H34.8005C35.905 2.00049 36.8005 2.89592 36.8005 4.00049V17.6449H26.1338V4.00049Z",
    fill: "#EB996E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 17.5005,
    width: 10,
    height: 23,
    fill: "#F4DFD4",
    stroke: "#F4AB85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7998 7.00049C36.7998 5.89592 37.6952 5.00049 38.7998 5.00049H45.4665C46.571 5.00049 47.4665 5.89592 47.4665 7.00049V20.6449H36.7998V7.00049Z",
    fill: "#EB996E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.2998,
    y: 21.145,
    width: 9.66667,
    height: 14.6444,
    fill: "#F4DFD4",
    stroke: "#F4AB85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.0005C5 8.89592 5.89543 8.00049 7 8.00049H13.6667C14.7712 8.00049 15.6667 8.89592 15.6667 10.0005V23.6449H5V10.0005Z",
    fill: "#EB996E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9707,
    y: 10.896,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(57.3968 14.9707 10.896)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.73145,
    y: 13.9443,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(57.3968 7.73145 13.9443)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6445,
    y: 14.7051,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(32.9906 11.6445 14.7051)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5322,
    y: 17.3804,
    width: 0.774167,
    height: 1.5134,
    transform: "rotate(69.5365 14.5322 17.3804)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4961,
    y: 14.6899,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(-30 13.4961 14.6899)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5791,
    y: 8.64502,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(-30 7.5791 8.64502)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 7.38477,
    y: 18.4082,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(27.7209 7.38477 18.4082)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 9.64551,
    y: 18.3428,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-24.1887 9.64551 18.3428)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1133,
    y: 23.1978,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-8.88161 13.1133 23.1978)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13.123,
    y: 7.00049,
    width: 0.459538,
    height: 1.39041,
    transform: "rotate(27.7209 13.123 7.00049)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2773,
    y: 20.2412,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(-4.02015 13.2773 20.2412)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9297,
    y: 11.4355,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(-4.02015 10.9297 11.4355)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3164,
    y: 17.2871,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(-122.603 16.3164 17.2871)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5557,
    y: 14.2388,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(-122.603 23.5557 14.2388)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6426,
    y: 13.478,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(-147.009 19.6426 13.478)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 17.791,
    y: 13.4932,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(150 17.791 13.4932)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 23.708,
    y: 19.5381,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(150 23.708 19.5381)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9023,
    y: 9.7749,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-152.279 23.9023 9.7749)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6416,
    y: 9.84033,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(155.811 21.6416 9.84033)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1738,
    y: 4.98535,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(171.118 18.1738 4.98535)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1641,
    y: 20.1826,
    width: 0.459538,
    height: 1.39041,
    transform: "rotate(-152.279 18.1641 20.1826)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0098,
    y: 7.94189,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(175.98 18.0098 7.94189)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3574,
    y: 16.7476,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(175.98 20.3574 16.7476)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 35.9707,
    y: 2.896,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(57.3968 35.9707 2.896)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7314,
    y: 5.94434,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(57.3968 28.7314 5.94434)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6445,
    y: 6.70508,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(32.9906 32.6445 6.70508)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 34.4961,
    y: 6.68994,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(-30 34.4961 6.68994)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5791,
    y: 0.64502,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(-30 28.5791 0.64502)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3848,
    y: 10.4082,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(27.7209 28.3848 10.4082)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6455,
    y: 13.3428,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-24.1887 29.6455 13.3428)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1133,
    y: 15.1978,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-8.88161 34.1133 15.1978)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 34.123,
    y: 0.000488281,
    width: 0.459538,
    height: 1.39041,
    transform: "rotate(27.7209 34.123 0.000488281)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2773,
    y: 12.2412,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(-4.02015 34.2773 12.2412)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9297,
    y: 3.43555,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(-4.02015 31.9297 3.43555)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 45.9707,
    y: 8.89551,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(57.3968 45.9707 8.89551)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7314,
    y: 11.9438,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(57.3968 38.7314 11.9438)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6445,
    y: 12.7046,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(32.9906 42.6445 12.7046)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4961,
    y: 12.6895,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(-30 44.4961 12.6895)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5791,
    y: 6.64453,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(-30 38.5791 6.64453)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3848,
    y: 16.4077,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(27.7209 38.3848 16.4077)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6455,
    y: 18.3423,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-24.1887 41.6455 18.3423)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1133,
    y: 21.1973,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-8.88161 44.1133 21.1973)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 44.123,
    y: 6,
    width: 0.459538,
    height: 1.39041,
    transform: "rotate(27.7209 44.123 6)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 44.2773,
    y: 18.2407,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(-4.02015 44.2773 18.2407)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9297,
    y: 9.43506,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(-4.02015 41.9297 9.43506)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2998,
    y: 23.9893,
    width: 9.66667,
    height: 14.6444,
    fill: "#F4DFD4",
    stroke: "#F4AB85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4668 9.84522C47.4668 8.74065 48.3622 7.84521 49.4668 7.84521H56.1335C57.238 7.84521 58.1335 8.74065 58.1335 9.84521V23.4897H47.4668V9.84522Z",
    fill: "#EB996E"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9668,
    y: 23.9893,
    width: 9.66667,
    height: 14.6444,
    fill: "#F4DFD4",
    stroke: "#F4AB85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1328 5.00049C58.1328 3.89592 59.0282 3.00049 60.1328 3.00049H66.7995C67.904 3.00049 68.7995 3.89592 68.7995 5.00049V18.6449H58.1328V5.00049Z",
    fill: "#EB996E"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6328,
    y: 19.145,
    width: 9.66667,
    height: 14.6444,
    fill: "#F4DFD4",
    stroke: "#F4AB85"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 24.0005,
    width: 10,
    height: 4,
    fill: "#F4AB85"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 19.0005,
    width: 9,
    height: 4,
    fill: "#F4AB85"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3164,
    y: 19.2866,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(-122.603 48.3164 19.2866)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5557,
    y: 16.2383,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(-122.603 55.5557 16.2383)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 51.6426,
    y: 15.4775,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(-147.009 51.6426 15.4775)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 49.791,
    y: 15.4927,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(150 49.791 15.4927)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 55.708,
    y: 21.5376,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(150 55.708 21.5376)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 55.9023,
    y: 11.7744,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-152.279 55.9023 11.7744)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 52.6416,
    y: 9.83984,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(155.811 52.6416 9.83984)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 50.1738,
    y: 6.98486,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(171.118 50.1738 6.98486)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 50.1641,
    y: 22.1821,
    width: 0.459538,
    height: 1.39041,
    transform: "rotate(-152.279 50.1641 22.1821)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 50.0098,
    y: 9.94141,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(175.98 50.0098 9.94141)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3574,
    y: 18.7471,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(175.98 52.3574 18.7471)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 67.9707,
    y: 3.89551,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(57.3968 67.9707 3.89551)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 60.7314,
    y: 6.94385,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(57.3968 60.7314 6.94385)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6445,
    y: 7.70459,
    width: 0.587048,
    height: 2.05467,
    transform: "rotate(32.9906 64.6445 7.70459)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4961,
    y: 7.68945,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(-30 66.4961 7.68945)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5791,
    y: 1.64453,
    width: 0.587048,
    height: 1.21159,
    transform: "rotate(-30 60.5791 1.64453)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 60.3848,
    y: 11.4077,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(27.7209 60.3848 11.4077)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 63.6455,
    y: 13.3423,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-24.1887 63.6455 13.3423)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 66.1133,
    y: 16.1973,
    width: 0.459538,
    height: 2.00876,
    transform: "rotate(-8.88161 66.1133 16.1973)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 66.123,
    y: 1,
    width: 0.459538,
    height: 1.39041,
    transform: "rotate(27.7209 66.123 1)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 66.2773,
    y: 13.2407,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(-4.02015 66.2773 13.2407)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 63.9297,
    y: 4.43506,
    width: 0.459538,
    height: 1.24085,
    transform: "rotate(-4.02015 63.9297 4.43506)",
    fill: "white",
    fillOpacity: 0.4
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    y: 49.8003,
    width: 72.8,
    height: 75.2,
    rx: 2,
    fill: "#FFF4EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 23C2.40039 21.8954 3.29582 21 4.40039 21H11.6441C12.4866 21 13.2388 21.528 13.5251 22.3203L17.4852 33.2797C17.7715 34.072 18.5237 34.6 19.3662 34.6H53.4546C54.2778 34.6 55.0169 34.0956 55.317 33.329L59.6457 22.271C59.9458 21.5044 60.6849 21 61.5081 21H69.2004C70.305 21 71.2004 21.8954 71.2004 23V56.6C71.2004 57.7046 70.305 58.6 69.2004 58.6H4.40039C3.29582 58.6 2.40039 57.7046 2.40039 56.6V23Z",
    fill: "#FFF4EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 51.8003C0 50.6957 0.89543 49.8003 2 49.8003H70.8C71.9046 49.8003 72.8 50.6957 72.8 51.8003V108.2L36.4 84.2003L0 108.2V51.8003Z",
    fill: "#E8505B"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5996,
    y: 60.2002,
    width: 45.6,
    height: 14.4,
    rx: 7.2,
    fill: "#FFF4EE"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    y: 118.6,
    width: 72.8,
    height: 3.2,
    fill: "#E8505B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoke);
export default __webpack_public_path__ + "static/media/smoke.9d763dec2e2452dee84387a6d9096179.svg";
export { ForwardRef as ReactComponent };